import CustomList from '../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../core/components/core/Util/List/CustomList/CustomListContainer';
import config from '../../../application/config/config';
import { useMemo } from 'react';
import { chooseProfileFilter } from '../../helpers/chooseProfileFilter';
import { loadData } from '../../../core/components/core/Util/List/CustomList/loadData';

function List() {

    const profileFilter = chooseProfileFilter(); 
    const pathFrontEnd = '/governanceroom/groups/';
    const paths = { 
        pathAdd: pathFrontEnd + 'add',
        pathEdit: pathFrontEnd + 'edit',
        pathView: pathFrontEnd + 'view',
        endpointDelete: `${config.endpoints.backend}governanceroom/groups/delete`,
        endpointCities: `${config.endpoints.backend}governanceroom/cities/getall`,
        endpoint: `${config.endpoints.backend}governanceroom/groups/getall`
    }

    const filters = {
        validateOnChange: true,
        showGoBackButton: false,
        showSubmitButton: false,
        handleSubmit: loadData,
        fields: [
            {
                name: 'group_name',
                type: 'text',
                label: 'Grupo',
                validations: {
                  required: false
                },
                columnSize: 4
            },
            {
                name: 'governance_room_city_id',
                type: 'select',
                label: 'Município',
                options: [],
                optionsEndpoint: {
                    endpoint: paths.endpointCities,
                    label: 'city_name',
                    value: 'id',
                    params: {
                        filter: {
                            where: {
                                profileFilter
                            }
                        }
                    }
                },
                validations: {
                    required: false
                },
                columnSize: 4
            },
            {
                name: 'filtro',
                type: 'submit',
                label: 'Pesquisar',
                columnSize: 1
            },
            {
                name: 'reset',
                type: 'reset',
                label: 'Limpar',
                columnSize: 2
            }
        ],
    };

    const list = useMemo(() => ({
        labelTitle: 'Grupos',
        labelTitleButtonAdd: 'Novo Grupo',
        showPrintButtons: false,
        formFilters: filters,
        fieldsShowOnDelete: ['description'],
        filter:{
          profileFilter
        },
        columns: [
            {
                name: 'city_name',
                label: 'Cidade',
                width: '25%'
            },
            {
                name: 'state_name',
                label: 'Estado',
                width: '25%'
            },
            {
                name: 'description',
                label: 'Grupo',
                width: '20%'
            }
        ],
        ...paths
    }), []);

    const content = useMemo(() => (
        <CustomList list={{ ...list, ...paths }} />
    ), [list]);

    const customListContainer = useMemo(() => (
    <CustomListContainer
        pathAdd={paths.pathAdd}
        labelTitle={list.labelTitle}
        labelTitleButtonAdd={list.labelTitleButtonAdd}
        content={content}
    />
    ), [content, list.labelTitle, list.labelTitleButtonAdd, paths.pathAdd]);
    
    return (
        <div>
            {customListContainer}
        </div>
    );
}
export default List;